import PropTypes from 'prop-types';
import { TextField, usePermissions, useRecordContext, useTranslate } from 'react-admin';
import { DetailsShow } from '@/components/global/drawers/DetailsShow.jsx';
import { DetailsActionsPopover } from '@/components/global/buttons/DetailsActionsPopover.jsx';
import CustomEditModalButton from '@/components/global/buttons/CustomEditModalButton.jsx';
import { useDrawer } from '@/composables/useDrawer.js';
import { canViewDetails } from '@/helpers/permissions/canViewDetails.js';

const MaterialDetailsActions = () => {
    const record = useRecordContext();
    const translate = useTranslate();
    const { permissions } = usePermissions();
    const { openDrawer } = useDrawer();

    if (!permissions?.isAdmin || !record?.id) {
        return null;
    }

    return (
        <DetailsActionsPopover>
            <CustomEditModalButton label={translate('resources.material.labels.editMaterial')} onOpen={() => openDrawer(record.id, 'material-edit')} />
        </DetailsActionsPopover>
    );
};

export const MaterialShow = ({ handleClose, elementId }) => {
    const translate = useTranslate();

    return (
        <DetailsShow
            handleClose={handleClose}
            elementId={elementId}
            resource='material'
            canView={permissions => canViewDetails('material', permissions)}
            actions={<MaterialDetailsActions />}
            showChangeHistory
        >
            <TextField source='id' label={translate('resources.contractor.fields.id')} />
            <TextField source='name' label={translate('common.name')} />
        </DetailsShow>
    );
};

MaterialShow.propTypes = {
    handleClose: PropTypes.func.isRequired,
    elementId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
